<template>
  <div>
    <z-centralized-toolbar>
      <v-toolbar-items>
        <v-btn text color="primary" :to="{name: 'ChequesLista'}" exact>
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      </v-toolbar-items>

      <template v-slot:actions>
        <v-switch color="primary" label="Cadastrar cheque em sequência" v-model="cadastrar_outro" hide-details v-if="$route.name == 'ChequesAdicionar'"></v-switch>
        <v-divider vertical class="mx-3"></v-divider>
        <v-btn text tabindex="-1" @click="$router.push({name: 'ChequesLista'})" :disabled="salvando">Cancelar</v-btn>
        <!-- <v-btn text color="primary" @click="$router.push({name: 'ChequesLista'})" :disabled="salvando">F2 - Salvar e Novo</v-btn> -->
        <v-btn depressed color="primary" @click="confirmar" :loading="salvando" :disabled="!form_valido">Salvar</v-btn>
        <!-- <v-btn color="primary" @click="cadastrar_outro = true; confirmar()" :loading="salvando" :disabled="!form_valido" v-if="this.$route.name == 'ChequesAdicionar'">Salvar e Novo</v-btn> -->
      </template>
    </z-centralized-toolbar>

    <z-container>
      <!-- <h3 class="headline">{{ titulo }} Cheque</h3> -->
      <v-form ref="form" v-model="form_valido" lazy-validation>
        <v-card>
          <v-card-text>

            <v-row dense>
              <v-col sm="4">
                <v-autocomplete autofocus ref="banco" placeholder=" " label="Banco" :rules="regras.banco" :items="$store.getters['listas/bancos']" v-model="cheque.banco" @keydown.enter.prevent="setFocus('agencia')" filled dense></v-autocomplete>
              </v-col>
              <v-col sm="2">
                <v-text-field ref="agencia" placeholder=" " label="Agência" :rules="regras.agencia" v-model="cheque.agencia" @keydown.enter="setFocus('conta')" filled dense></v-text-field>
              </v-col>
              <v-col sm="2">
                <v-text-field ref="conta" placeholder=" " label="Conta" :rules="regras.conta" v-model="cheque.conta" @keydown.enter="setFocus('numero')" filled dense></v-text-field>
              </v-col>
              <v-col sm="2">
                <v-text-field ref="numero" placeholder=" " label="Número" :rules="regras.numero" v-model="cheque.numero" @keydown.enter="setFocus('valor')" filled dense></v-text-field>
              </v-col>
              <v-col sm="2">
                <z-campo-valor ref="valor" placeholder=" " label="Valor" :rules="regras.valor" v-model="cheque.valor" @keydown.enter="setFocus('vencimento')" filled dense></z-campo-valor>
              </v-col>
              <v-col sm="2">
                <z-date-picker-menu ref="vencimento" placeholder=" " label="Vencimento" :rules="regras.vencimento" v-model="cheque.vencimento" @keydown.enter="setFocus('cpfcnpj')" filled dense></z-date-picker-menu>
              </v-col>
              <v-col sm="3">
                <z-cpf-cnpj ref="cpfcnpj" placeholder=" " label="CPF/CNPJ" :rules="regras.cpfcnpj" v-model="cheque.cpfcnpj" @input="buscarEmitente(cheque.cpfcnpj)" :loading="buscando_emitente" @keydown.enter="setFocus('cidade')" filled dense></z-cpf-cnpj>
              </v-col>
              <v-col sm="5">
                <v-text-field ref="cidade" placeholder=" " label="Cidade" :rules="regras.cidade" v-model="cheque.cidade" @keydown.native.enter="$refs.estado.focus()" filled dense></v-text-field>
              </v-col>
              <v-col sm="2">
                <v-autocomplete ref="estado" placeholder="" label="Estado" :rules="regras.estado" v-model="cheque.estado" :items="$globals.ESTADOS" @keydown.enter.prevent="$refs.emitente.focus()" filled dense></v-autocomplete>
              </v-col>
              <v-col sm="5">
                <v-text-field ref="emitente" placeholder=" " label="Nome do Emitente" :rules="regras.emitente" v-model="cheque.emitente" @keydown.enter="setFocus('telefone')" filled dense></v-text-field>
              </v-col>
              <v-col sm="2">
                <v-text-field ref="telefone" v-mask="$globals.CELULAR_MASK" placeholder=" " label="Telefone Emitente" v-model="cheque.telefone" mask="(##) #####-####" return-masked-value @keydown.enter="setFocus('responsavel')" filled dense></v-text-field>
              </v-col>
              <v-col sm="5">
                <v-autocomplete ref="responsavel" placeholder=" " label="Cliente Responsável" :rules="regras.responsavel" :items="$store.getters['listas/clientes']" v-model="cheque.cliente_id" filled dense></v-autocomplete>
              </v-col>
            </v-row>


            <v-row>
              <v-col cols="12">
                <v-textarea label="Observações" v-model="cheque.observacoes" filled dense></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

        </v-card>
      </v-form>
    </z-container>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
    name: 'cheques-form',

    data() {
        return {
          cheque: {
            telefone: ''
          },
          salvando: false,
          buscando_emitente: false,
          form_valido: false,
          regras: {
            banco: [v => !!v || 'O banco é obrigatório'],
            agencia: [v => !!v || 'O agência é obrigatório'],
            conta: [v => !!v || 'O conta é obrigatório'],
            numero: [v => !!v || 'O numero é obrigatório'],
            valor: [v => v != '0,00' || 'O valor é obrigatório'],
            vencimento: [v => !!v || 'O vencimento é obrigatório'],
            cpfcnpj: [
              v => !!v || 'O cpf/cnpj é obrigatório',
              v => this.$validacoes.validarCPFCNPJ(v) || 'CPF ou CNPJ inválido'
            ],
            cidade: [v => !!v || 'O cidade é obrigatório'],
            estado: [v => !!v || 'O estado é obrigatório'],
            emitente: [v => !!v || 'O emitente é obrigatório'],
            responsavel: [v => !!v || 'O responsável é obrigatório'],
          },
          tab: '',
          cadastrar_outro: false,
        };
    },

    beforeRouteLeave(to, from, next) {
        this.UNSET_CHEQUE();
        next();
    },

    async mounted() {
      this.setTitulo(this.titulo);
      this.$store.dispatch('listas/clientes');
      this.$store.dispatch('listas/bancos');

        if (this.$route.name == "ChequesEditar") {
            if (!this.$store.state.cheques.cheque) {
                if (this.$route.params.id) {
                    await this.abrir(this.$route.params.id);
                }
            }
            this.cheque = this.clone(this.$store.state.cheques.cheque);
        }
    },

    methods: {
        ...mapMutations(['setTitulo']),
        ...mapMutations('cheques', ['UNSET_CHEQUE']),
        ...mapActions('cheques', ['abrir', 'atualizar', 'salvar', 'emitente']),

        async confirmar() {
          if (this.$refs.form.validate()) {
            try {
              this.salvando = true;

              if (this.$route.params.id) {
                  await this.atualizar(this.cheque);
              } else {
                  await this.salvar(this.cheque);
                  if (this.cadastrar_outro) {
                    this.cheque.numero = parseInt(this.cheque.numero) + 1;
                    // this.cheque.valor = '';
                    // this.cheque.vencimento = '';
                    this.setFocus('valor');
                    this.$refs.form.resetValidation();
                    return;
                  }
              }
              
              this.$router.push({ path: "/cheques/controle" });
              this.$eventbus.notificar("Cheque salvo com sucesso");
            } catch(error) {
              if (error.response && error.response.status == 400) {
                this.$eventbus.erroSistema('Esse cheque já foi cadastrado');
              } else {
                this.$eventbus.erro('Não foi possível salvar este Cheque. Verifique os dados do cheque e tente novamente.', error);
              }
            } finally {
               this.salvando = false;
            }
          }
        },

        async buscarEmitente(cpfcnpj) {
          if (cpfcnpj.length == 14 || cpfcnpj.length == 18) {
            try {
              this.buscando_emitente = true;
              let emitente = await this.emitente(cpfcnpj);
              if (emitente) {
                this.cheque.cidade      = emitente.cidade;
                this.cheque.estado      = emitente.estado;
                this.cheque.emitente    = emitente.emitente;
                this.cheque.telefone    = emitente.telefone;
                this.cheque.cliente_id = emitente.cliente_id;
              }
            } catch (error) {
              console.log(error.response.data.message);
            } finally {
              this.buscando_emitente = false;
            }
          }
        }
    },

    computed: {
      titulo() {
        let titulo = this.$route.meta.editando ? 'Editar' : 'Adicionar';
        return titulo + ' ' + 'Cheque';
      }
    },
};
</script>

<style scoped>
/* .container.grid-list-md .layout .flex{
    padding-top: 0px;
    padding-right: 4px;
    padding-bottom: 0px;
    padding-left: 4px;
} */
</style>
